<ion-header [translucent]="true" *ngIf="detail">
  <ion-toolbar>
    <ion-buttons slot="start">
      <app-back-button defaultHref="/add-sport"></app-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="editMode = !editMode">
        <ion-icon [name]="editMode ? 'close-outline' : 'create-outline'"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title><app-logo [height]="30"></app-logo></ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" *ngIf="detail">
  <ng-container *ngIf="!editMode">
    <ion-header collapse="condense">
      <ion-toolbar>
        <ion-title size="large">{{detail.sportName}}</ion-title>
      </ion-toolbar>
    </ion-header>

    <!-- Image Section -->
    <div *ngIf="detail.imageUrl" class="image-container">
      <ion-img [src]="detail.imageUrl" alt="Exercise image"></ion-img>
    </div>

    <app-db-exercise-img
      *ngIf="dbExercise"
      [img1]="dbExercise.images[0]"
      [img2]="dbExercise.images[1]"
    ></app-db-exercise-img>

    <app-detail-chart [exerciseHistories]="exerciseHistories"></app-detail-chart>

    <ion-card *ngIf="dbExercise">
      <ion-card-content>
        <ion-list lines="none">
          <ion-item>
            <ion-label>Force: {{ dbExercise.force }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-label>Level: {{ dbExercise.level }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-label>Mechanic: {{ dbExercise.mechanic }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-label>Equipment: {{ dbExercise.equipment }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-label>Category: {{ dbExercise.category }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-label>Primary Muscles:</ion-label>
            <div>
              <ion-chip *ngFor="let muscle of dbExercise.primaryMuscles">
                <ion-label>{{ muscle }}</ion-label>
              </ion-chip>
            </div>
          </ion-item>
          <ion-item>
            <ion-label>Secondary Muscles:</ion-label>
            <div>
              <ion-chip *ngFor="let muscle of dbExercise.secondaryMuscles">
                <ion-label>{{ muscle }}</ion-label>
              </ion-chip>
            </div>
          </ion-item>
        </ion-list>
      </ion-card-content>
    </ion-card>

    <!-- Description Section -->
    <ion-card *ngIf="detail.description || dbExercise">
      <ion-card-content *ngIf="detail.description">
        <ion-text>{{detail.description}}</ion-text>
      </ion-card-content>
      <ion-card-content *ngIf="dbExercise">
        <p *ngFor="let instruction of dbExercise.instructions">{{instruction}}</p>
      </ion-card-content>
    </ion-card>

    <div class="px">
      <app-select-muscle-group
      *ngIf="detail.hashtags"
      title="Primary muscles"
      [hashtags]="detail.hashtags"
      [preview]="true"
    ></app-select-muscle-group>

    <app-select-muscle-group
      *ngIf="detail.secondaryHashtags"
      title="Secondary muscles"
      [hashtags]="detail.secondaryHashtags"
      [preview]="true"
    ></app-select-muscle-group>
    </div>

    <ion-list>
      <ion-list-header>
        <ion-label style="max-width: 110px;">Date</ion-label>
        <ion-label>Reps x Weight</ion-label>
      </ion-list-header>
      <ion-item-sliding *ngFor="let history of exerciseHistories">
      <ion-item>
        <ion-label style="max-width: 100px;">
          {{ history.createdAt! | firestoreTimestamp }}
        </ion-label>
        <ion-label>
          <ion-chip *ngFor="let rep of history.reps; let i = index">
            {{ rep }} x {{ history.weights[i] }}
          </ion-chip>
        </ion-label>
      </ion-item>
      <ion-item-options side="end">
        <ion-item-option (click)="removeHistory(history)" color="danger">Delete</ion-item-option>
      </ion-item-options>
    </ion-item-sliding>
    </ion-list>
  </ng-container>

  <ng-container *ngIf="editMode">
    <app-create-exercise
      [sportName]="detail.sportName"
      [description]="detail.description!"
      [imagePreview]="detail.imageUrl!"
      [confirmText]="'Confirm change'"
      [hashtags]="detail.hashtags"
      [secondaryHashtags]="detail.secondaryHashtags"
      (emitCreatedExercse)="changeExercise($event)"
    >
    </app-create-exercise>
  </ng-container>
</ion-content>
